import { QueryClient } from '@tanstack/react-query';

/**
 * `networkMode: 'always'`: never pause on `navigator.onLine`. Windows reports "No Internet access"
 * on corporate networks whose proxy blocks its connectivity probe, while requests work fine; with
 * react-query's default ('online') every query then pauses before sending anything and stays
 * loading forever, with no error (Fizzy 3129). A real outage still surfaces as a failed request.
 *
 * `refetchOnReconnect: true`: since a query started during a real outage now fails instead of
 * waiting, it refetches when the browser comes back online. Only stale queries refetch, so
 * `staleTime: Infinity` data that loaded fine is not re-requested.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			networkMode: 'always',
			refetchOnWindowFocus: false,
			refetchOnMount: false,
			refetchOnReconnect: true,
		},
		mutations: {
			networkMode: 'always',
		},
	},
});
